import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { UserAuthorization } from 'src/api/types';
import handleAPIError from 'src/api/errors';
import { zustandAuthorizationStorageName } from 'src/utils/cookieHelper';
import customCookieStorage from 'src/utils/CustomCookiesStorage';
import { mountStoreDevtool } from 'simple-zustand-devtools';

interface State {
  setUserAuthorization: (authObj: UserAuthorization) => void;
  removeUserAuthorization: () => void;
  setIsStoreInitialized: (value: boolean) => void;
  setUserToken: (token: string) => void;
  setUserPhone: (phone: string) => void;
  isStoreInitialized: boolean;
  userToken: string;
  userPhone: string;
}

const useAuthorizationStore = create<State>()(
  persist(
    (set) => ({
      setUserAuthorization: (authObj: UserAuthorization) => {
        try {
          if (authObj.token) {
            set({
              userToken: authObj.token,
              userPhone: authObj?.phone
            });
          } else {
            throw new Error(`No token returned: ${JSON.stringify(authObj)}`);
          }
        } catch (error) {
          // error might happen if cookie is broken
          handleAPIError(error);
        }
      },
      removeUserAuthorization: () => {
        try {
          set({ userToken: null, userPhone: null });
        } catch (error) {
          // error might happen if cookie is broken
          handleAPIError(error);
        }
      },
      setIsStoreInitialized: (value) => set({ isStoreInitialized: value }),
      setUserToken: (token) => set({ userToken: token }),
      setUserPhone: (phone) => set({ userPhone: phone }),
      isStoreInitialized: false,
      userToken: null,
      userPhone: null
    }),
    {
      name: zustandAuthorizationStorageName,
      storage: createJSONStorage(() => customCookieStorage)
    }
  )
);

export const authorizationStoreFallback: State = {
  setUserAuthorization: () => null,
  removeUserAuthorization: () => null,
  setIsStoreInitialized: () => null,
  setUserToken: () => null,
  setUserPhone: () => null,
  isStoreInitialized: false,
  userToken: null,
  userPhone: null
};

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('AuthorizationStore', useAuthorizationStore);
}

export default useAuthorizationStore;
